<template>
    <div class="conditions-filter">
        <button class="mobile-trigger" @click="toggleConditions">
            <span>{{ "map.conditions" | trans }}</span>
            <img :src="mobileImg" alt="Toggle" />
        </button>

        <div class="filter">
            <div class="switch">
                <input
                    id="show-conditions"
                    type="checkbox"
                    v-model="conditions"
                />
                <label for="show-conditions" class="label">
                    <span class="_switch-control"></span>
                    {{ "map.show_road_conditions" | trans }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            conditions: true,
        };
    },

    watch: {
        conditions(newVal, oldVal) {
            this.$store.commit("setData", {
                name: "showExtraordinary",
                data: newVal,
            });
        },
    },

    methods: {
        toggleConditions() {
            this.conditions = !this.conditions;
        },
    },

    computed: {
        mobileImg() {
            if (this.conditions) {
                return "/svg/map/hac-stanje-mobile-green.svg";
            }

            return "/svg/map/hac-stanje-mobile-grey.svg";
        },
    },
};
</script>
